import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import enTranslations from "../locales/en.json";
import deTranslations from "../locales/de.json";

const storedLanguage =
  typeof window !== "undefined"
    ? window.localStorage.getItem("preferredLanguage")
    : null;
const browserLanguage =
  typeof navigator !== "undefined" ? navigator.language : "en";
const initialLanguage =
  storedLanguage ??
  (browserLanguage.toLowerCase().startsWith("de") ? "de" : "en");

i18n.use(initReactI18next).init({
  resources: {
    en: {
      translation: enTranslations,
    },
    de: {
      translation: deTranslations,
    },
  },
  lng: initialLanguage,
  fallbackLng: "en",
  supportedLngs: ["en", "de"],
  debug: true,
  interpolation: {
    escapeValue: false, // React already escapes values
  },
});

export default i18n;

